import { schema } from 'normalizr'

const smsMessagesSchema = new schema.Entity('smsMessages', { idAttribute: 'id' })
const smsMessagesArray = [smsMessagesSchema]

export default smsMessagesArray



// WEBPACK FOOTER //
// ./src/schemas/sms.js